module.exports = __webpack_public_path__ + "img/35C.bbb88ddc.png";